module.exports = __webpack_public_path__ + "static/media/dodoairlines.4e458c74.png";